import DispatchConstants from 'app/shared/constants/DispatchConstants';
import CompanyUser from 'app/shared/model/CompanyUser';
import LoadingConstants from 'app/shared/constants/LoadingConstants';

const emptyUser = new CompanyUser();

const initState = () => ({
    ...emptyUser,
    userLoadingState: LoadingConstants.INITIAL,
    userErrorMessage: null,
    isInvitation: false,
    properties: [],
    propertiesLoadingState: LoadingConstants.INITIAL,
    propertiesError: null,
    isFormChanged: false,
    availableProperties: [],
    availablePropertiesLoadingState: LoadingConstants.INITIAL,
});

const currentUser = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.USER_MANAGEMENT_CURRENT_USER_INIT:
            return initState();
        case DispatchConstants.USER_MANAGEMENT_INIT_INVITATION:
            return {
                ...state,
                isInvitation: true,
                userLoadingState: LoadingConstants.SUCCESS,
                permissions: {
                    ADD_LISTING: true,
                    UPDATE_LISTING: true,
                    VIEW_INVOICE: true,
                    VIEW_CONTACT: true,
                    RESPOND_REVIEW: true,
                    VIEW_ANALYTICS: true,
                },
            };
        case DispatchConstants.USER_MANAGEMENT_SET_CURRENT_USER_NAME:
            return {
                ...state,
                userName: action.payload.userName,
            };
        case DispatchConstants.USER_MANAGEMENT_SET_CURRENT_USER_AVAILABLE_PROPERTIES:
            return {
                ...state,
                availableProperties: action.payload.availableProperties,
                availablePropertiesLoadingState: LoadingConstants.SUCCESS,
            };
        case DispatchConstants.USER_MANAGEMENT_SET_CURRENT_USER_PERMISSIONS:
            return {
                ...state,
                permissions: payload.permissions,
                isFormChanged: true,
            };
        case DispatchConstants.USER_MANAGEMENT_SET_CURRENT_USER_EMAIL:
            return {
                ...state,
                email: action.payload.email,
            };
        case DispatchConstants.USER_MANAGEMENT_GET_CURRENT_USER_INFO_LOADING:
            return {
                ...state,
                userLoadingState: LoadingConstants.LOADING,
            };
        case DispatchConstants.USER_MANAGEMENT_GET_CURRENT_USER_INFO_SUCCESS:
            return {
                ...state,
                ...payload.user,
                userLoadingState: LoadingConstants.SUCCESS,
            };
        case DispatchConstants.USER_MANAGEMENT_GET_CURRENT_USER_INFO_FAIL:
            return {
                ...state,
                ...emptyUser,
                userErrorMessage: payload.error,
                userLoadingState: LoadingConstants.FAIL,
            };
        case DispatchConstants.USER_MANAGEMENT_GET_CURRENT_USER_PROPERTIES_LOADING:
            return {
                ...state,
                propertiesLoadingState: LoadingConstants.LOADING,
            };
        case DispatchConstants.USER_MANAGEMENT_GET_CURRENT_USER_PROPERTIES_SUCCESS:
            return {
                ...state,
                properties: payload.properties,
                propertiesLoadingState: LoadingConstants.SUCCESS,
            };
        case DispatchConstants.USER_MANAGEMENT_GET_CURRENT_USER_PROPERTIES_FAIL:
            return {
                ...state,
                properties: [],
                propertiesLoadingState: LoadingConstants.FAIL,
                propertiesError: payload.error,
            };
        case DispatchConstants.USER_MANAGEMENT_SET_CURRENT_USER_PROPERTIES:
            return {
                ...state,
                properties: payload.properties,
                isFormChanged: true,
            };
        default:
            return state;
    }
};

export default currentUser;
